import React from "react";
import { Grid } from "@mui/material";
import { observer } from "mobx-react-lite";
import { QuestionAutocompleteSkills } from "../../atoms/QuestionAutocompleteSkills";
import { QuestionAutocompleteTopics } from "../../atoms/QuestionAutocompleteTopics";
import { TexHelpersAutocomplete } from "../../atoms/TexHelpersAutocomplete";
import { useFormContext } from "react-hook-form";
import { QuestionTypes } from "../../../../../static/enums/Questions";

interface QuestionAutocompleteSectionProps {
	prefix?: string;
}

export default observer(function QuestionAutocompleteSection({ prefix }: QuestionAutocompleteSectionProps) {
	const { getValues } = useFormContext();
	const withTexHelpers = ![
		QuestionTypes.choice_text_single,
		QuestionTypes.choice_text_multiple,
		QuestionTypes.upload_handwriting,
	].includes(getValues(`${prefix}class`));

	return (
		<Grid container item xs={12}>
			<QuestionAutocompleteTopics prefix={prefix} />
			<QuestionAutocompleteSkills prefix={prefix} />
			{withTexHelpers ? <TexHelpersAutocomplete prefix={prefix} /> : null}
		</Grid>
	);
});
